import { createFederationStorage } from "@constructor/federation-common/base";
function useFederationRootStorages() {
  const storages = /* @__PURE__ */ new Map();
  return {
    create,
    get,
    clear
  };
  function get(name) {
    return storages.get(name);
  }
  function create(name) {
    if (!storages.has(name)) {
      storages.set(name, createFederationStorage());
    }
    return storages.get(name);
  }
  function clear(name) {
    storages.delete(name);
  }
}
export {
  useFederationRootStorages as u
};
//# sourceMappingURL=rootStorages.js.map
